/* eslint-disable */
import React, { useEffect } from "react";
import Lottie from "react-lottie";
import moment from "moment";
//#end Global Imports

//#Local Imports
import Button from "../../components/ui/Button";
import { kycDocsId, kycVerificationAgreementNote, verifiedDocumentsData } from "../../utils";
import { LeftArrowIcon, ReloadIcon } from "../../assets/Icons";
import Typograpy from "../../components/ui/Typography";
import { getUserDocs } from "../../services/userDetails";
import * as animationData from "../../assets/lottieAnimationsData/scanDocuments.json";
import {
  downloadCKYC,
  eVerifyDL,
  eVerifyPan,
  eVerifyVoterIdCard,
  getCkycStatus,
  sendAadharOTP,
  sendCkycOtp,
  uploadDocuments,
  validateAadharOTP,
  validateCkycOtp,
  verifyAadharCard,
  searchCkyc,
  verifyDrivingLicenseDocument,
  verifyPassportBack,
  verifyPassportFront,
  verifyVoterIdCardDocument,
  uploadAadharBack,
} from "../../services/kyc";
import KycModals from "./KycModals";
import { AxiosResponse } from "axios";
import IUserDocuments from "./userDocuments";

import { Axios } from "../../services/axios";

import Loader from "../../components/ui/Loader";
import { Mixpanel } from "../../constants/mixpanel";
//#end Local Imports

const UserDocuments = () => {
  const [isModalOpen, setIsModalOpen] = React.useState<string>("");
  const [isAgree, setIsAgree] = React.useState<boolean>(false);
  const [isReSendOtp, setIsReSendOtp] = React.useState<boolean>(false);
  const [docType, setDocType] = React.useState<string>("");
  const [adharOTPValue, saveAdharOTPValue] = React.useState<string>("");
  const [adharOTPError, setAdharOTPError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now());
  const [dateKey, saveDateKey] = React.useState(0);
  const [isDocScan, setIsDocScan] = React.useState<boolean>(false);
  const [docDob, setDocDob] = React.useState("");
  const [entityId, setEntityId] = React.useState<string>("");
  const [otpReferenceNo, setOtpReferenceNo] = React.useState<string>("");
  const [uploadedFileData, setUploadedFileData] = React.useState({
    pdfFile: false,
    fileName: "",
  });
  const [aadhaarLinked, setAadhaarLinked] = React.useState<boolean>(true);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    if (isModalOpen !== "1") {
      Mixpanel.track("KYC completed popup");
    }
  }, [isModalOpen]);

  const [panCardDetails, setPanCardDetails] = React.useState({
    panNumber: "",
    panNameOnCard: "",
    panRequestId: "",
    isPanVerified: false,
    isPanUploaded: false,
    uploadedPanFile: "",
    messagePan: "",
    uploadedDocError: "",
    ocrPanCardNumber: "",
    messagePanVerified: "",
  });
  const [adharCardDetails, setAdharCardDetails] = React.useState({
    aadharNumber: "",
    aadharNameOnCard: "",
    isAadharDocVerified: false,
    isAadharBackUploaded: false,
    isAadharDocUploaded: false,
    uploadedAdharFrontFile: "",
    uploadedAdharBackFile: "",
    messageAadhar: "",
    uploadedDocError: "",
    uploadedBackError: "",
  });
  const [drivingLicenseDetails, setDrivingLicenseDetails] = React.useState({
    dlNumber: "",
    dlNameOnCard: "",
    dlRequestId: "",
    isDlDocVerified: false,
    isDLFrontUploaded: false,
    uploadedDlFrontFile: "",
    dlBackFile: "",
    isDLBackUploaded: false,
    dlBackImageFileName: "",
    messageDLVerified: "",
    uploadedDocError: "",
    ocrDrivingLicenseNumber: "",
    errorMessageDLVerified: "",
    dlDob: "",
  });
  const [passportDetails, setPassportDetails] = React.useState({
    passportIdNumber: "",
    passportBackIdNumber: "",
    passportNameOnCard: "",
    uploadedPassportFrontFile: "",
    isPassportDocVerified: false,
    isPassportDocUploaded: false,
    isPassportBackDocVerified: false,
    isPassportBackUploaded: false,
    uploadedPassportBackFile: "",
    messagePassport: "",
    messageBackPassport: "",
    passportAddress: "",
    passportCity: "",
    passportState: "",
    passportDob: "",
    passportPincode: "",
    uploadedFrontDocError: "",
    uploadedBackDocError: "",
  });
  const [voterIDCardDetails, setVoterIDCardDetails] = React.useState({
    voterNumber: "",
    voterNameOnCard: "",
    voterRequestId: "",
    isVIDocVerified: false,
    isVoterFrontUploaded: false,
    uploadedVoterFrontCardFile: "",
    voterBackCardFile: "",
    isVoterBackUploaded: false,
    VoterIdBackImageFileName: "",
    messageVIVerify: "",
    uploadedDocError: "",
    ocrVoterIdCardNumber: "",
  });
  const [preViewImageSrc, setPreViewImageSrc] = React.useState("");
  const [numberOfVerifiedDoc, setNumberOfVerifiedDoc] = React.useState<number>(0);
  const [ckycPhase, setCKYCPhase] = React.useState<number>(1);
  const [ckycData, setCkycData] = React.useState({} as IUserDocuments.ckycData);
  const [ckycAdharOTPValue, saveCkycAdharOTPValue] = React.useState<string>("");
  const [ckycMessage, setCkycMessage] = React.useState({ successMsg: "", errorMsg: "" });
  const [ckycStatus, setCkycStatus] = React.useState<string>("");
  const [buttonLoader, setButtonLoader] = React.useState({
    aadhaarOtpLoader: false,
    verifyCkycOtpLoader: false,
    downloadCkycOtpLoader: false,
    sendCkycOtpLoader: false,
    validateCkycOtpLoader: false,
    everifyDLLoader: false,
    passportVerificationLoader: false,
    passportBackVerificationLoader: false,
    eVerifyPanCard: false,
    eVerifyVoterCard: false,
  });
  const isUseEffectFired = React.useRef(false);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const userRemitterId = localStorage.getItem("userRemitterId") || "";

  const defaultAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  useEffect(() => {
    if (numberOfVerifiedDoc === 1 || numberOfVerifiedDoc === 1) {
      Mixpanel.track(`Submit ${numberOfVerifiedDoc} of 2`);
    }
  }, [numberOfVerifiedDoc]);

  const handlerCkycStatus = () => {
    return getCkycStatus(Number(userRemitterId))
      .then((response) => {
        setCkycStatus(response?.data);
        return response?.data;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const commonHandler = (response: AxiosResponse<any, any>, ckycStatusValue: string) => {
    setNumberOfVerifiedDoc(
      response?.data?.isDocVerified
        ? 2
        : response?.data?.userDocs?.filter((value: { docName: string | string[] }) =>
            value.docName.includes("PAN_CARD"),
          )?.length === 1
        ? 1
        : 0,
    );
    if ("doc_dob" in response.data) {
      setDocDob(response.data.doc_dob);
    }

    response?.data["isDocVerified"]
      ? ""
      : response?.data["userDocs"]?.length > 0
      ? response?.data["userDocs"]
          .filter((value: { docName: string | string[] }) => value.docName.includes("PAN_CARD"))
          .map((panCardDetails: { isVerified: boolean }) => panCardDetails.isVerified)[0]
        ? ckycStatusValue === "FAILED"
          ? (setIsModalOpen("2"), setDocType("AADHAR_CARD"))
          : (setIsModalOpen("2"), setDocType("AADHAR_CARD"))
        : (setIsModalOpen("2"), setDocType("PAN_CARD"))
      : (setIsModalOpen("1"), setDocType("PAN_CARD"));
    response?.data["userDocs"].length > 0 &&
      response?.data["userDocs"].map(
        (values: {
          idDoc: number;
          idNumber: string;
          nameOnCard: string;
          request_id: string;
          isVerified: boolean;
        }) => {
          if (values.idDoc === kycDocsId.E_VERIFY_PAN) {
            setPanCardDetails((preValue) => {
              return {
                ...preValue,
                panNumber: values.idNumber,
                panNameOnCard: values.nameOnCard,
                panRequestId: values.request_id,
                isPanVerified: values.isVerified,
                isPanUploaded: values.isVerified ? true : false,
              };
            });
          } else if (values.idDoc === kycDocsId.VERIFY_AADHAR_CARD) {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                aadharNumber: values.idNumber,
                aadharNameOnCard: values.nameOnCard,
                isAadharDocVerified: values.isVerified,
                isAadharDocUploaded: values.isVerified ? true : false,
              };
            });
          } else if (values.idDoc === kycDocsId.PASSPORT_FRONT) {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                passportIdNumber: values.idNumber,
                passportNameOnCard: values.nameOnCard,
                isPassportDocVerified: values.isVerified,
                isPassportDocUploaded: values.isVerified ? true : false,
              };
            });
          } else if (values.idDoc === kycDocsId.PASSPORT_BACK) {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                isPassportBackDocVerified: true,
              };
            });
          } else if (values.idDoc === kycDocsId.E_VERIFY_DL) {
            setDrivingLicenseDetails((preValue) => {
              return {
                ...preValue,
                dlNumber: values.idNumber,
                dlNameOnCard: values.nameOnCard,
                dlRequestId: values.request_id,
                isDlDocVerified: values.isVerified,
                isDLFrontUploaded: values.isVerified ? true : false,
              };
            });
          } else if (values.idDoc === kycDocsId.VERIFY_DL_DOC) {
            setDrivingLicenseDetails((preValue) => {
              return {
                ...preValue,
                isDLBackUploaded: values.isVerified ? true : false,
              };
            });
          } else if (values.idDoc === kycDocsId.E_VERIFY_VOTERID) {
            setVoterIDCardDetails((preValue) => {
              return {
                ...preValue,
                voterNumber: values.idNumber,
                voterNameOnCard: values.nameOnCard,
                voterRequestId: values.request_id,
                isVIDocVerified: values.isVerified,
                isVoterFrontUploaded: values.isVerified ? true : false,
              };
            });
          }
        },
      );
  };

  React.useEffect(() => {
    if (!isUseEffectFired.current) {
      isUseEffectFired.current = true;

      getUserDocs(currentUser)
        .then((response) => {
          handlerCkycStatus()
            .then((ckycStatusValue) => {
              commonHandler(response, ckycStatusValue);
            })
            .catch(() => {
              commonHandler(response, "");
              setCkycMessage({
                successMsg: "",
                errorMsg: "Something Went Wrong!",
              });
              setCkycStatus("FAILED");
              setCKYCPhase(2);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const handleAadharBackUpload = (e: any) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    uploadAadharBack(data).then((res: any) => {
      setAdharCardDetails({ ...adharCardDetails, isAadharBackUploaded: true });
    });
  };

  React.useEffect(() => {
    adharOTPValue.length === 6 && validateAadharOtp();
  }, [adharOTPValue]);

  const handleChangeUpload = (e: { target: { files: string | any[] } }, docType: string) => {
    const data = new FormData();
    if (e.target.files.length === 1) {
      if (
        e.target.files[0].name.split(".")[1] === "pdf" ||
        e.target.files[0].name.split(".")[1] === "PDF"
      ) {
        setUploadedFileData({
          pdfFile: true,
          fileName: e.target.files[0].name,
        });
      } else {
        setUploadedFileData({
          pdfFile: false,
          fileName: e.target.files[0].name,
        });
      }

      const imagedata = e.target.files[0];
      data.append("file", imagedata);
      data.append("doc_type", docType);
      if (docType === "PAN_CARD") {
        setPanCardDetails((preValue) => {
          return { ...preValue, uploadedPanFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("Upload PAN");
        setIsDocScan(true);
      } else if (docType === "AADHAR_CARD") {
        setAdharCardDetails((preValue) => {
          return { ...preValue, uploadedAdharFrontFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("Aadhar card uploaded_front");
        setIsDocScan(true);
      } else if (docType === "AADHAR_CARD_BACK") {
        setAdharCardDetails((preValue) => {
          return { ...preValue, uploadedAdharBackFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("Aadhar card uploaded_back");
        const data = new FormData();
        data.append("file", e.target.files[0]);

        const headers = {
          Authorization: currentUser.idToken,
          // Add other headers if required
        };
        Axios.put(`/remit/users/${vendorUserKey}/documents/${kycDocsId.UPLOAD_AADHAR_BACK}`, data, {
          headers: headers,
        })
          .then((response) => {
            setAdharCardDetails({ ...adharCardDetails, isAadharBackUploaded: true });
          })
          .catch((error) => {
            console.error("Error", error);
          });
      } else if (docType === "VOTER_CARD") {
        setVoterIDCardDetails((preValue) => {
          return {
            ...preValue,
            uploadedVoterFrontCardFile: URL.createObjectURL(e.target.files[0]),
          };
        });
        Mixpanel.track("VoterID  uploaded_front");
        setIsDocScan(true);
      } else if (docType === "DRIVING_LICENCE") {
        setDrivingLicenseDetails((preValue) => {
          return { ...preValue, uploadedDlFrontFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("DL uploaded_front");
        setIsDocScan(true);
        data.append("doc_dob", docDob);
      } else if (docType === "PASSPORT_BACK") {
        setPassportDetails((preValue) => {
          return { ...preValue, uploadedPassportBackFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("Passport uploaded_back");
        setIsDocScan(true);
      } else {
        setPassportDetails((preValue) => {
          return { ...preValue, uploadedPassportFrontFile: URL.createObjectURL(e.target.files[0]) };
        });
        Mixpanel.track("Passport uploaded_front");
        setIsDocScan(true);
      }
    }

    setPanCardDetails((preValue) => {
      return {
        ...preValue,
        uploadedDocError: "",
      };
    });
    setAdharCardDetails((preValue) => {
      return {
        ...preValue,
        uploadedDocError: "",
      };
    });
    setDrivingLicenseDetails((preValue) => {
      return {
        ...preValue,
        uploadedDocError: "",
      };
    });
    setVoterIDCardDetails((preValue) => {
      return {
        ...preValue,
        uploadedDocError: "",
      };
    });
    setPassportDetails((preValue) => {
      return {
        ...preValue,
        uploadedFrontDocError: "",
        uploadedBackDocError: "",
      };
    });

    !adharCardDetails?.isAadharDocUploaded &&
      uploadDocuments(data)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 299) {
            if (docType === "PAN_CARD") {
              setPanCardDetails((preValue) => {
                return {
                  ...preValue,
                  isPanUploaded: true,
                  panNumber: response?.data?.idNumber,
                  ocrPanCardNumber: response?.data?.idNumber,
                  panNameOnCard: response?.data?.nameOnCard,
                  panRequestId: response?.data?.request_id,
                };
              });
              setDocDob(response?.data.doc_dob);
              setIsDocScan(false);
            } else if (docType === "AADHAR_CARD") {
              setAdharCardDetails((preValue) => {
                return {
                  ...preValue,
                  isAadharDocUploaded: true,
                  aadharNumber: response?.data?.idNumber,
                  aadharNameOnCard: response?.data?.nameOnCard,
                };
              });
              setIsDocScan(false);
            } else if (docType === "VOTER_CARD") {
              setVoterIDCardDetails((preValue) => {
                return {
                  ...preValue,
                  isVoterFrontUploaded: true,
                  voterNumber: response?.data?.idNumber,
                  ocrVoterIdCardNumber: response?.data?.idNumber,
                  voterNameOnCard: response?.data?.nameOnCard,
                  voterRequestId: response?.data?.request_id,
                };
              });
              setIsDocScan(false);
            } else if (docType === "DRIVING_LICENCE") {
              setDrivingLicenseDetails((preValue) => {
                return {
                  ...preValue,
                  isDLFrontUploaded: true,
                  dlNumber: response?.data?.idNumber,
                  ocrDrivingLicenseNumber: response?.data?.idNumber,
                  dlNameOnCard: response?.data?.nameOnCard,
                  dlRequestId: response?.data?.request_id,
                  dlDob: response.data.doc_dob,
                };
              });
              setDocDob(response?.data.doc_dob);
              setIsDocScan(false);
            } else if (docType === "PASSPORT_BACK") {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportBackUploaded: true,
                  passportIdNumber: response?.data?.idNumber,
                  passportAddress: response?.data?.address,
                  passportCity: response?.data?.city,
                  passportState: response?.data?.state,
                  passportDob: response?.data?.doc_dob,
                  passportPincode: response?.data?.pincode,
                };
              });
              setIsDocScan(false);
            } else {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportDocUploaded: true,
                  passportIdNumber: response?.data?.idNumber,
                  passportNameOnCard: response?.data?.nameOnCard,
                };
              });
              setIsDocScan(false);
            }
          }
        })
        .catch((reason) => {
          if (reason.response) {
            if (docType === "PAN_CARD") {
              setPanCardDetails((preValue) => {
                return {
                  ...preValue,
                  isPanUploaded: false,
                  uploadedDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            } else if (docType === "AADHAR_CARD") {
              setAdharCardDetails((preValue) => {
                return {
                  ...preValue,
                  isAadharDocUploaded: false,
                  uploadedDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            } else if (docType === "VOTER_CARD") {
              setVoterIDCardDetails((preValue) => {
                return {
                  ...preValue,
                  isVoterFrontUploaded: false,
                  uploadedDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            } else if (docType === "DRIVING_LICENCE") {
              setDrivingLicenseDetails((preValue) => {
                return {
                  ...preValue,
                  isDlFrontUploaded: false,
                  uploadedDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            } else if (docType === "PASSPORT_BACK") {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportBackUploaded: false,
                  uploadedBackDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            } else {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportDocUploaded: false,
                  uploadedFrontDocError: reason?.response?.data?.error?.type,
                };
              });
              setIsDocScan(false);
            }
          }
        });
  };

  const handleEVerifyVoterCard = async () => {
    setIsDocScan(true);
    const data = new FormData();

    await fetch(voterIDCardDetails.uploadedVoterFrontCardFile)
      .then((image) => image.blob())
      .then((blob) => {
        const file = new File([blob], uploadedFileData.fileName);
        data.append("file", file);
      });
    data.append("doc_type", docType);
    data.append("id_number", voterIDCardDetails.ocrVoterIdCardNumber);
    data.append("edited_id_number", voterIDCardDetails.voterNumber);
    data.append("name_on_card", voterIDCardDetails.voterNameOnCard);
    data.append("request_id", voterIDCardDetails.voterRequestId);
    data.append("doc_dob", docDob);
    setVoterIDCardDetails((preValue) => {
      return {
        ...preValue,
        messageVIVerify: "",
      };
    });

    setButtonLoader((prev) => ({ ...prev, eVerifyVoterCard: true }));
    eVerifyVoterIdCard(data)
      .then(async (response) => {
        if (response?.data?.type === "success") {
          Mixpanel.track("VoterID verified");
          const data = new FormData();
          await fetch(voterIDCardDetails.voterBackCardFile)
            .then((image) => image.blob())
            .then((blob) => {
              const file = new File([blob], voterIDCardDetails.VoterIdBackImageFileName);
              data.append("file", file);
            });
          data.append("doc_dob", docDob);
          data.append("doc_type", "VOTER_CARD_BACK");
          data.append("name_on_card", voterIDCardDetails.voterNameOnCard);
          data.append("request_id", voterIDCardDetails.voterRequestId);
          data.append("idNumber", voterIDCardDetails.voterNumber);
          data.append("doc_name", response?.data?.result?.docName);
          data.append("id", response?.data?.result?.id);

          verifyVoterIdCardDocument(data)
            .then(() => {
              setNumberOfVerifiedDoc(2);
              setVoterIDCardDetails((preValue) => {
                return {
                  ...preValue,
                  isVIDocVerified: true,
                };
              });
              setIsDocScan(false);
            })
            .catch(() => {
              setIsDocScan(false);
            });
        } else {
          setVoterIDCardDetails((preValue) => {
            return {
              ...preValue,
              messageVIVerify: response?.data?.message,
              isVIDocVerified: false,
            };
          });
          setIsDocScan(false);
        }
      })
      .catch((reason) => {
        if (reason.response) {
          setVoterIDCardDetails((preValue) => {
            return {
              ...preValue,
              messageVIVerify: reason?.response?.data?.error?.type,
            };
          });
          setIsDocScan(false);
        } else if (reason.request) {
          setVoterIDCardDetails((preValue) => {
            return {
              ...preValue,
              messageVIVerify: "Something Went Wrong, Slow Connection",
            };
          });
          setIsDocScan(false);
        } else {
          setVoterIDCardDetails((preValue) => {
            return {
              ...preValue,
              messageVIVerify: "Something Went Wrong, Please Refresh and Upload again",
            };
          });
          setIsDocScan(false);
        }
      })
      .finally(() => setButtonLoader((prev) => ({ ...prev, eVerifyVoterCard: false })));
  };

  const handleEverifyDL = async () => {
    const data = new FormData();
    setIsDocScan(true);
    await fetch(drivingLicenseDetails.uploadedDlFrontFile)
      .then((image) => image.blob())
      .then((blob) => {
        const file = new File([blob], uploadedFileData.fileName);
        data.append("file", file);
      });
    data.append("doc_type", docType);
    data.append("id_number", drivingLicenseDetails.ocrDrivingLicenseNumber);
    data.append("edited_id_number", drivingLicenseDetails.dlNumber);
    data.append("name_on_card", drivingLicenseDetails.dlNameOnCard);
    data.append("request_id", drivingLicenseDetails.dlRequestId);
    data.append("doc_dob", docDob);
    setDrivingLicenseDetails((preValue) => {
      return {
        ...preValue,
        messageDLVerified: "",
        errorMessageDLVerified: "",
      };
    });

    setButtonLoader((prev) => ({ ...prev, everifyDLLoader: true }));
    eVerifyDL(data)
      .then(async (response) => {
        if (response?.data?.type === "success") {
          const data = new FormData();
          await fetch(drivingLicenseDetails.dlBackFile)
            .then((image) => image.blob())
            .then((blob) => {
              const file = new File([blob], drivingLicenseDetails.dlBackImageFileName);
              data.append("file", file);
            });
          data.append("doc_dob", docDob);
          data.append("doc_type", "DRIVING_LICENCE_BACK");
          data.append("name_on_card", drivingLicenseDetails.dlNameOnCard);
          data.append("request_id", drivingLicenseDetails.dlRequestId);
          data.append("idNumber", drivingLicenseDetails.dlNumber);
          data.append("doc_name", response?.data?.result?.docName);
          data.append("id", response?.data?.result?.id);

          verifyDrivingLicenseDocument(data)
            .then(() => {
              setNumberOfVerifiedDoc(2);
              setDrivingLicenseDetails((preValue) => {
                return {
                  ...preValue,
                  messageDLVerified: response?.data?.message,
                  errorMessageDLVerified: "",
                  isDlDocVerified: true,
                };
              });
              setIsDocScan(false);
              Mixpanel.track("DL verified");
              setTimeout(
                () =>
                  setDrivingLicenseDetails((preValue) => {
                    return { ...preValue, messageDLVerified: "" };
                  }),
                5000,
              );
            })
            .catch((err) => {
              setIsDocScan(false);
              setDrivingLicenseDetails((preValue) => {
                return {
                  ...preValue,
                  messageDLVerified: "",
                  errorMessageDLVerified: err.response.data.error.type,
                };
              });
            })
            .finally(() => setButtonLoader((prev) => ({ ...prev, everifyDLLoader: false })));
          setTimeout(
            () =>
              setDrivingLicenseDetails((preValue) => {
                return { ...preValue, messageDLVerified: "", errorMessageDLVerified: "" };
              }),
            5000,
          );
        } else {
          setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              messageDLVerified: "",
              errorMessageDLVerified: response.data.message,
              isDlDocVerified: false,
            };
          });
          setIsDocScan(false);
        }
      })
      .catch((err) => {
        if (err.response) {
          setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              messageDLVerified: "",
              errorMessageDLVerified: err.response.data.error.type,
            };
          });
          setIsDocScan(false);
        } else if (err.request) {
          setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              errorMessageDLVerified: "Something Went Wrong, Slow Connection",
            };
          });
          setIsDocScan(false);
        } else {
          setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              errorMessageDLVerified: "Something Went Wrong, Please Refresh and Upload again",
            };
          });
          setIsDocScan(false);
        }
      })
      .finally(() => setButtonLoader((prev) => ({ ...prev, everifyDLLoader: false })));
  };

  const handleEVerifyPanCard = async () => {
    setIsDocScan(true);
    const data = new FormData();

    await fetch(panCardDetails.uploadedPanFile)
      .then((r) => r.blob())
      .then((blob) => {
        const file = new File([blob], uploadedFileData.fileName);
        data.append("file", file);
      });
    data.append("doc_type", docType);
    data.append("id_number", panCardDetails.ocrPanCardNumber);
    data.append("edited_id_number", panCardDetails.panNumber);
    data.append("name_on_card", panCardDetails.panNameOnCard);
    data.append("request_id", panCardDetails.panRequestId);
    data.append("doc_dob", docDob);
    setPanCardDetails((preValue) => {
      return {
        ...preValue,
        messagePan: "",
        messagePanVerified: "",
      };
    });

    setButtonLoader((prev) => ({ ...prev, eVerifyPanCard: true }));
    eVerifyPan(data)
      .then((response) => {
        const res = JSON.stringify(response?.data);
        const obj = JSON.parse(res);
        if (response?.data.type === "success") {
          setNumberOfVerifiedDoc(1);
          Mixpanel.track("PAN verified");
          setAadhaarLinked(response?.data?.aadhaarLinked);
          setPanCardDetails((preValue) => {
            return {
              ...preValue,
              isPanVerified: obj.resultDTO.isVerified,
              messagePanVerified: obj.message,
              messagePan: "",
              uploadedPanFile: "",
            };
          });
          setIsDocScan(false);
        } else {
          setPanCardDetails((preValue) => {
            return {
              ...preValue,
              isPanVerified: false,
              messagePanVerified: "",
              messagePan: response?.data?.message,
            };
          });
          setIsDocScan(false);
        }
        setTimeout(
          () =>
            setPanCardDetails((preValue) => {
              return {
                ...preValue,
                messagePan: "",
                messagePanVerified: "",
              };
            }),
          5000,
        );
      })
      .catch((err) => {
        if (err.response) {
          setPanCardDetails((preValue) => {
            return {
              ...preValue,
              messagePanVerified: "",
              messagePan: err?.response?.data?.error?.type,
            };
          });

          setIsDocScan(false);
        } else {
          setPanCardDetails((preValue) => {
            return {
              ...preValue,
              messagePanVerified: "",
              messagePan: "Something Went Wrong, Please Refresh and Upload again",
            };
          });
          setTimeout(
            () =>
              setPanCardDetails((preValue) => {
                return {
                  ...preValue,
                  messagePan: "",
                  messagePanVerified: "",
                };
              }),
            5000,
          );
          setIsDocScan(false);
        }
      })
      .finally(() => setButtonLoader((prev) => ({ ...prev, eVerifyPanCard: false })));
  };

  const sendAdharOtp = async () => {
    saveDateKey(dateKey + 1);
    saveDate(Date.now() + 180000);
    setIsDocScan(true);
    const body = {
      aadharNo: adharCardDetails.aadharNumber,
      userId: vendorUserKey,
    };

    try {
      setButtonLoader((prev) => ({ ...prev, aadhaarOtpLoader: true }));
      sendAadharOTP(body)
        .then((response) => {
          if (response["data"]["success"]) {
            setEntityId(response["data"]["entityId"]);
            setOtpReferenceNo(response["data"]["otpReferenceNo"]);
            setIsDocScan(false);
          } else {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: "Something went wrong",
              };
            }),
              setIsDocScan(false);
          }
        })
        .catch((err) => {
          if (err.response !== undefined) {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: "Something Went Wrong Upload Again",
              };
            }),
              setIsDocScan(false);
          } else {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: err?.response?.data?.error?.type,
              };
            });
          }
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, aadhaarOtpLoader: false })));
    } catch (error) {
      setAdharCardDetails((preValue) => {
        return {
          ...preValue,
          messageAadhar: "something went wrong",
        };
      }),
        setIsDocScan(false);
    }
  };

  const validateAadharOtp = async () => {
    setIsDocScan(true);
    setAdharCardDetails((preValue) => {
      return {
        ...preValue,
        messageOTP: "",
      };
    });
    const body = {
      otpReferenceNo: otpReferenceNo,
      entityId: entityId,
      aadharNo: adharCardDetails.aadharNumber,
      otp: adharOTPValue,
      userId: vendorUserKey,
    };

    try {
      validateAadharOTP(body)
        .then((response: any) => {
          if (response["data"]["success"]) {
            saveAdharOTPValue("");
            handleVerifyAdharCard();
          } else {
            setAdharOTPError("Something went wrong");
            saveAdharOTPValue("");
            setIsDocScan(false);
          }
        })
        .catch((err: any) => {
          if (err.response !== undefined) {
            setAdharOTPError(err?.response?.data?.error?.type + " " + "Retry Again");
            saveAdharOTPValue("");
            setIsDocScan(false);
          }
        });
    } catch (error) {
      setAdharOTPError("Something Went Wrong" + " " + "retry Again");
      setIsDocScan(false);
    }
  };

  const handleVerifyAdharCard = async () => {
    setButtonLoader((prev) => ({ ...prev, aadhaarOtpLoader: true }));
    const data = new FormData();
    setIsDocScan(true);
    setAdharCardDetails((preValue) => {
      return {
        ...preValue,
        messageAadhar: "",
      };
    });
    data.append("doc_type", "AADHAR_CARD");
    data.append("id_number", adharCardDetails.aadharNumber);
    data.append("name_on_card", adharCardDetails.aadharNameOnCard);

    await fetch(adharCardDetails.uploadedAdharFrontFile)
      .then((image) => image.blob())
      .then((blob) => {
        const file = new File([blob], uploadedFileData.fileName);
        data.append("file", file);
      });

    try {
      verifyAadharCard(data)
        .then((response) => {
          if (response?.data.type === "success") {
            setNumberOfVerifiedDoc(2);
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                isAadharDocVerified: true,
                uploadedAdharFrontFile: "",
              };
            });
            setIsDocScan(false);
            Mixpanel.track("Aadhar OTP verified");
          } else {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: response?.data?.message,
                isAadharDocVerified: false,
              };
            });
            setIsDocScan(false);
          }
        })
        .catch((err) => {
          if (err.response) {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: err?.response?.data?.error?.type,
              };
            }),
              setIsDocScan(false);
          } else if (err.request) {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: "Something Went Wrong, Slow Connection maybe",
              };
            }),
              setIsDocScan(false);
          } else {
            setAdharCardDetails((preValue) => {
              return {
                ...preValue,
                messageAadhar: "Something Went Wrong, Please Refresh and Upload again",
              };
            }),
              setIsDocScan(false);
          }
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, aadhaarOtpLoader: false })));
    } catch (error) {
      {
        console.error(error);
      }
    }
  };

  const handleContinueWithoutNumber = async () => {
    const result = handleVerifyAdharCard();
  };

  const handlePassportVerification = async () => {
    setIsDocScan(true);
    const data = new FormData();
    data.append("doc_type", docType);
    data.append("id_number", passportDetails.passportIdNumber);
    data.append("name_on_card", passportDetails.passportNameOnCard);

    await fetch(passportDetails.uploadedPassportFrontFile)
      .then((image) => image.blob())
      .then((blob) => {
        const file = new File([blob], uploadedFileData.fileName);
        data.append("file", file);
      });
    setPassportDetails((preValue) => {
      return {
        ...preValue,
        messagePassport: "",
      };
    });

    try {
      setButtonLoader((prev) => ({ ...prev, passportVerificationLoader: true }));
      verifyPassportFront(data)
        .then((response) => {
          if (response?.data?.type === "success") {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                isPassportDocVerified: true,
                uploadedPassportFrontFile: "",
              };
            });
            setIsDocScan(false);
          } else {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                messagePassport: response?.data?.message,
              };
            });
          }
          setIsDocScan(false);
        })
        .catch((err) => {
          if (err.response) {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                messagePassport: err?.response?.data?.error?.type,
              };
            });

            setIsDocScan(false);
          } else if (err.request) {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                messagePassport: "Something Went Wrong, Slow Connection maybe",
              };
            });

            setIsDocScan(false);
          } else {
            setPassportDetails((preValue) => {
              return {
                ...preValue,
                messagePassport: "Something Went Wrong, Please Refresh and Upload again",
              };
            });
            setIsDocScan(false);
          }
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, passportVerificationLoader: false })));
    } catch (error) {
      {
        console.error(error);
      }
    }
  };

  const handlePassportBackVerification = async () => {
    setIsDocScan(true);
    if (!passportDetails.passportBackIdNumber) {
      setIsDocScan(false);
      setPassportDetails((preValue) => {
        return { ...preValue, messageBackPassport: "Please enter valid file number" };
      });

      setTimeout(() => {
        setPassportDetails((preValue) => {
          return { ...preValue, messageBackPassport: "" };
        });
      }, 3000);
    } else {
      const data = new FormData();
      data.append("doc_type", "PASSPORT_BACK");
      data.append("id_number", passportDetails.passportIdNumber);
      data.append("file_number", passportDetails.passportBackIdNumber);
      data.append("pincode", passportDetails.passportPincode);
      data.append("address", passportDetails.passportAddress);
      data.append("city", passportDetails.passportCity);
      data.append("state", passportDetails.passportState);
      data.append("doc_dob", passportDetails.passportDob);

      await fetch(passportDetails.uploadedPassportBackFile)
        .then((r) => r.blob())
        .then((blob) => {
          const file = new File([blob], uploadedFileData.fileName);
          data.append("file", file);
        });

      try {
        setButtonLoader((prev) => ({ ...prev, passportBackVerificationLoader: true }));
        verifyPassportBack(data)
          .then((response) => {
            if (response?.data?.type === "success") {
              setNumberOfVerifiedDoc(2);
              Mixpanel.track("Passport verified");
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportBackDocVerified: true,
                  uploadedPassportFrontFile: "",
                  messagePassport: "",
                  messageBackPassport: "",
                };
              });
              setIsDocScan(false);
            } else {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  isPassportBackDocVerified: false,
                  messagePassport: "",
                  messageBackPassport: response?.data?.message,
                };
              });
              setIsDocScan(false);
            }
          })
          .catch((reason) => {
            if (reason.response) {
              setPassportDetails((preValue) => {
                return { ...preValue, messageBackPassport: reason?.response?.data?.error?.type };
              });

              setIsDocScan(false);
            } else if (reason.request) {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  messageBackPassport: "Something Went Wrong, Slow Connection maybe",
                };
              });

              setIsDocScan(false);
            } else {
              setPassportDetails((preValue) => {
                return {
                  ...preValue,
                  messageBackPassport: "Something Went Wrong, Please Refresh and Upload again",
                };
              });
              setIsDocScan(false);
            }
          })
          .finally(() =>
            setButtonLoader((prev) => ({ ...prev, passportBackVerificationLoader: false })),
          );
      } catch (reason) {
        {
          throw reason;
        }
      }
    }
  };

  const getColor = (value: string) => {
    switch (value) {
      case "AADHAR_CARD":
        return adharCardDetails.isAadharDocVerified;
      case "DRIVING_LICENCE":
        return drivingLicenseDetails.isDlDocVerified;
      case "PASSPORT_FRONT":
        return passportDetails.isPassportDocVerified && passportDetails?.isPassportBackDocVerified;
      case "VOTER_CARD":
        return voterIDCardDetails.isVIDocVerified;
      default:
        return false;
    }
  };

  const handlePreviewUploadedDoc = (docType: string) => {
    setIsModalOpen("preViewUploadedDoc");

    switch (docType) {
      case "PAN_CARD":
        return setPreViewImageSrc(panCardDetails.uploadedPanFile);
      case "AADHAR_CARD":
        return setPreViewImageSrc(adharCardDetails.uploadedAdharFrontFile);
      case "DRIVING_LICENCE_FRONT":
        return setPreViewImageSrc(drivingLicenseDetails.uploadedDlFrontFile);
      case "DRIVING_LICENCE_BACK":
        return setPreViewImageSrc(drivingLicenseDetails.dlBackFile);
      case "INDIAN_PASSPORT_FRONT":
        return setPreViewImageSrc(passportDetails.uploadedPassportFrontFile);
      case "INDIAN_PASSPORT_BACK":
        return setPreViewImageSrc(passportDetails.uploadedPassportBackFile);
      case "VOTER_CARD_FRONT":
        return setPreViewImageSrc(voterIDCardDetails.uploadedVoterFrontCardFile);
      case "VOTER_CARD_BACK":
        return setPreViewImageSrc(voterIDCardDetails.voterBackCardFile);
      default:
        return "";
    }
  };

  const handleDeleteDoc = () => {
    return docType === "PAN_CARD"
      ? setPanCardDetails({
          panNumber: "",
          panNameOnCard: "",
          panRequestId: "",
          isPanVerified: false,
          isPanUploaded: false,
          uploadedPanFile: "",
          messagePan: "",
          uploadedDocError: "",
          ocrPanCardNumber: "",
          messagePanVerified: "",
        })
      : docType === "AADHAR_CARD"
      ? setAdharCardDetails({
          aadharNumber: "",
          aadharNameOnCard: "",
          isAadharDocVerified: false,
          isAadharDocUploaded: false,
          uploadedAdharFrontFile: "",
          messageAadhar: "",
          uploadedDocError: "",
          isAadharBackUploaded: false,
          uploadedAdharBackFile: "",
          uploadedBackError: "",
        })
      : docType === "DRIVING_LICENCE"
      ? drivingLicenseDetails.isDLBackUploaded
        ? setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              dlBackFile: "",
              isDLBackUploaded: false,
              dlBackImageFileName: "",
              messageDLVerified: "",
              uploadedDocError: "",
              errorMessageDLVerified: "",
            };
          })
        : setDrivingLicenseDetails((preValue) => {
            return {
              ...preValue,
              isDlDocVerified: false,
              isDLFrontUploaded: false,
              uploadedDlFrontFile: "",
              messageDLVerified: "",
              uploadedDocError: "",
              dlNumber: "",
              dlNameOnCard: "",
              dlRequestId: "",
              ocrDrivingLicenseNumber: "",
              errorMessageDLVerified: "",
            };
          })
      : docType === "PASSPORT_FRONT"
      ? passportDetails.isPassportBackUploaded
        ? setPassportDetails((preValue) => {
            return {
              ...preValue,
              passportBackIdNumber: "",
              isPassportBackDocVerified: false,
              isPassportBackUploaded: false,
              uploadedPassportBackFile: "",
              messageBackPassport: "",
              uploadedBackDocError: "",
              passportAddress: "",
              passportCity: "",
              passportState: "",
              passportDob: "",
              passportPincode: "",
            };
          })
        : setPassportDetails((preValue) => {
            return {
              ...preValue,
              passportIdNumber: "",
              passportNameOnCard: "",
              uploadedPassportFrontFile: "",
              isPassportDocVerified: false,
              isPassportDocUploaded: false,
              messagePassport: "",
              uploadedFrontDocError: "",
            };
          })
      : docType === "VOTER_CARD" && voterIDCardDetails.isVoterBackUploaded
      ? setVoterIDCardDetails((preValue) => {
          return {
            ...preValue,
            voterBackCardFile: "",
            isVoterBackUploaded: false,
            VoterIdBackImageFileName: "",
            messageVIVerify: "",
            uploadedDocError: "",
          };
        })
      : setVoterIDCardDetails((preValue) => {
          return {
            ...preValue,
            voterNumber: "",
            voterNameOnCard: "",
            voterRequestId: "",
            isVIDocVerified: false,
            isVoterFrontUploaded: false,
            uploadedVoterFrontCardFile: "",
            messageVIVerify: "",
            uploadedDocError: "",
            ocrVoterIdCardNumber: "",
          };
        });
  };

  const handlePanDobChangeHandler = (value: any) => {
    setDocDob(moment(value).format("DD/MM/YYYY").toString());
  };

  const handleDlDobChangeHandler = (value: any) => {
    setDocDob(moment(value).format("DD/MM/YYYY").toString());
  };

  const handlePassportDobChangeHandler = (value: any) => {
    setPassportDetails((preValue) => {
      return { ...preValue, passportDob: moment(value).format("DD/MM/YYYY").toString() };
    });
    setDocDob(moment(value).format("DD/MM/YYYY").toString());
  };

  const verifyCKYCHandler = async () => {
    setLoading(true);
    setButtonLoader((prev) => ({ ...prev, verifyCkycOtpLoader: true }));
    try {
      searchCkyc()
        .then((response) => {
          setLoading(false);
          setCKYCPhase(2);
          setCkycData(response?.data);
          setCkycMessage({
            successMsg: response?.data?.active ? "Congratulations! CKYC Id  Found" : "",
            errorMsg: response?.data?.errorMessage,
          });
          response?.data?.errorMessage !== "" &&
            response?.data?.errorMessage !== null &&
            setCkycStatus("FAILED");
        })
        .catch((err) => {
          setLoading(false);
          err?.response?.data?.error?.type !== "" &&
            err?.response?.data?.error?.type !== null &&
            setCkycStatus("FAILED");
          setCkycMessage({ successMsg: "", errorMsg: err?.response?.data?.error?.type });
          setCKYCPhase(2);
          throw err;
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, verifyCkycOtpLoader: false })));
    } catch (error) {
      {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const downloadCkycHandler = async () => {
    try {
      setButtonLoader((prev) => ({ ...prev, downloadCkycOtpLoader: true }));
      downloadCKYC(ckycData?.ckycNumber)
        .then((response) => {
          setCkycData({
            ...ckycData,
            ckycEmailAdd: response?.data?.ckycEmailAdd,
            ckycMobileNumber: response?.data?.ckycMobileNumber,
          });
          setCkycMessage({
            successMsg: response?.data?.active ? "Congratulations! CKYC details downloaded" : "",
            errorMsg: response?.data?.errorMessage,
          });
          setCKYCPhase(3);
          response?.data?.errorMessage !== "" &&
            response?.data?.errorMessage !== null &&
            setCkycStatus("FAILED");
        })
        .catch((err) => {
          setCkycMessage({ successMsg: "", errorMsg: err?.data?.type });
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, downloadCkycOtpLoader: false })));
    } catch (error) {
      {
        console.error(error);
      }
    }
  };

  const sendCkycOtpHandler = async () => {
    saveDateKey(dateKey + 1);
    saveDate(Date.now() + 60000);
    try {
      setButtonLoader((prev) => ({ ...prev, sendCkycOtpLoader: true }));
      sendCkycOtp(ckycData?.ckycNumber)
        .then((response) => {
          setCkycData({ ...ckycData, entityId: response?.data?.entityId });
          setCKYCPhase(4);
          setIsReSendOtp(true);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, sendCkycOtpLoader: false })));
    } catch (error) {
      {
        console.error(error);
      }
    }
  };

  const validateCkycOtpHandler = async () => {
    const body = {
      vendorUserId: Number(userRemitterId),
      ckycNumber: ckycData?.ckycNumber,
      otp: Number(ckycAdharOTPValue),
    };

    try {
      setButtonLoader((prev) => ({ ...prev, validateCkycOtpLoader: true }));
      validateCkycOtp(body)
        .then((response) => {
          if (response.data.isVerified) {
            setNumberOfVerifiedDoc(2);
            setCkycStatus("COMPLETED");
            setCkycData({
              ...ckycData,
              ckycOtpMessage: "",
            });
            setIsReSendOtp(false);
          }
          setCKYCPhase(4);
        })
        .catch((err) => {
          setCkycData({
            ...ckycData,
            ckycOtpMessage: err?.response?.data?.error?.type,
          });
        })
        .finally(() => setButtonLoader((prev) => ({ ...prev, validateCkycOtpLoader: false })));
    } catch (error) {
      {
        console.error(error);
      }
    }
  };

  const preViewModalButton = (
    <Button
      bgColor="bg-secondary-600"
      fontStyle={{
        fontFamily: "",
        fontSize: "text-sm",
        fontWeight: "font-medium ",
        fontColor: "text-white",
      }}
      borderStyle={{
        borderRadius: "rounded",
      }}
      className="w-full px-10 py-2"
      onClickHandler={handleDeleteDoc}
    >
      <div className="mr-1">
        <ReloadIcon />
      </div>
      Re-upload
    </Button>
  );

  const preViewModalHeader = (
    <div className="flex items-center justify-start">
      <div
        className="flex items-center justify-between mr-4 lg:hidden"
        onClick={() => (docType === "" ? setIsModalOpen("") : setIsModalOpen("2"))}
      >
        <LeftArrowIcon />
      </div>
      <div className="items-center justify-between hidden mr-10 lg:flex">
        <Button
          bgColor="bg-primary-450"
          fontStyle={{
            fontFamily: "",
            fontSize: "text-sm",
            fontWeight: "font-medium",
            fontColor: "text-primary",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          className="py-2 px-[18px]"
          onClickHandler={() => (docType === "" ? setIsModalOpen("") : setIsModalOpen("2"))}
        >
          {"<< Go Back"}
        </Button>
      </div>
      <Typograpy
        tagType="div"
        text="Document Preview"
        className="text-black font-normal font-lato text-[32px] mr-[26px] hidden lg:flex"
      />
      <Typograpy
        tagType="div"
        text={uploadedFileData.fileName}
        className="text-2xl font-normal text-primary-400 font-lato"
      />
    </div>
  );

  return (
    <div className="flex flex-col flex-1 lg:mt-12">
      {loading ? (
        <div className="w-3/5 self-center">
          <Loader />
        </div>
      ) : (
        <KycModals
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          aadhaarLinked={aadhaarLinked}
          docType={docType}
          numberOfVerifiedDoc={numberOfVerifiedDoc}
          panCardDetails={panCardDetails}
          setDocType={setDocType}
          verifiedDocumentsData={verifiedDocumentsData}
          getColor={getColor}
          handlePreviewUploadedDoc={handlePreviewUploadedDoc}
          handleDeleteDoc={handleDeleteDoc}
          handleChangeUpload={handleChangeUpload}
          handleEVerifyPanCard={handleEVerifyPanCard}
          adharCardDetails={adharCardDetails}
          setDrivingLicenseDetails={setDrivingLicenseDetails}
          sendAdharOtp={sendAdharOtp}
          buttonLoader={buttonLoader}
          entityId={entityId}
          dateKey={dateKey}
          date={date}
          saveAdharOTPValue={saveAdharOTPValue}
          adharOTPError={adharOTPError}
          drivingLicenseDetails={drivingLicenseDetails}
          handleEverifyDL={handleEverifyDL}
          passportDetails={passportDetails}
          handlePassportBackVerification={handlePassportBackVerification}
          handlePassportVerification={handlePassportVerification}
          voterIDCardDetails={voterIDCardDetails}
          setVoterIDCardDetails={setVoterIDCardDetails}
          handleEVerifyVoterCard={handleEVerifyVoterCard}
          kycVerificationAgreementNote={kycVerificationAgreementNote}
          preViewModalHeader={preViewModalHeader}
          preViewModalButton={preViewModalButton}
          preViewImageSrc={preViewImageSrc}
          isAgree={isAgree}
          setIsAgree={setIsAgree}
          isPDFfile={uploadedFileData.pdfFile}
          setPassportDetails={setPassportDetails}
          setPanCardDetails={setPanCardDetails}
          handlePanDobChangeHandler={handlePanDobChangeHandler}
          handleDlDobChangeHandler={handleDlDobChangeHandler}
          handlePassportDobChangeHandler={handlePassportDobChangeHandler}
          docDob={docDob}
          ckycPhase={ckycPhase}
          verifyCKYCHandler={verifyCKYCHandler}
          downloadCkycHandler={downloadCkycHandler}
          sendCkycOtpHandler={sendCkycOtpHandler}
          saveCkycAdharOTPValue={saveCkycAdharOTPValue}
          ckycMessage={ckycMessage}
          ckycStatus={ckycStatus}
          ckycData={ckycData}
          validateCkycOtpHandler={validateCkycOtpHandler}
          isReSendOtp={isReSendOtp}
          handleVerifyAdharCard={handleContinueWithoutNumber}
        />
      )}
      {isDocScan && (
        <div className="fixed z-50 flex-1 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
          <Lottie options={defaultAnimationOptions} height={400} width={400} ariaRole="animation" />
        </div>
      )}
    </div>
  );
};

export default UserDocuments;
